<template>
  <el-card class="app-table-container" :body-style="{ padding: '20px' }">
    <div slot="header">
      <div class="global-table-header">
        <div class="global-table-header-left">
          <span>KEY：</span>
          <ListSearch ref="listSearch" @listSearchEvn="listSearchEvn" />
        </div>
        <div class="global-table-header-right">
          <el-select
            v-model="params.lang"
            @change="changelang"
            placeholder="根据语言筛选"
            value-key="value"
            clearable
            filterable
          >
            <el-option
              v-for="(item, index) in langData"
              :key="index"
              :label="item.desc"
              :value="item.lang"
            >
            </el-option>
          </el-select>
          <button class="global-button-style" @click="createPrompt">
            新建
          </button>
        </div>
      </div>
    </div>
    <div class="global-body-wrap">
      <TableView
        :tableData="tableData"
        :tableProp="tableProp"
        handleWidth="200"
        :handleBtn="handleBtn"
        @tableHandle="tableHandle"
      />
    </div>
    <Pagination :pageSize="params.pageSize" :total="total" @pageNum="pageNum" />
  </el-card>
</template>

<script>
import TableView from '@/components/tableView'
import Pagination from '@/components/pagination'
import ListSearch from '@/components/listSearch'

export default {
  components: {
    TableView,
    ListSearch,
    Pagination
  },
  computed: {
    tableProp() {
      let tableProp = [
        {
          prop: 'key',
          label: 'KEY'
        },
        {
          prop: 'lang',
          label: '语言'
        },
        {
          prop: 'scene',
          label: '场景'
        },
        {
          prop: 'desc',
          label: '提示词'
        }
      ]
      return tableProp
    },
    handleBtn() {
      return [
        { style: 'checkDetailsBtn', type: 'edit', title: '编辑' },
        { style: 'delBtn', type: 'del', title: '删除' }
      ]
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      params: { pageSize: 20, page: 1 },
      langData: []
    }
  },
  methods: {
    async getCountryList() {
      try {
        let res = await this.$http.getCountryList({ pageSize: 1000, page: 1 })
        this.langData = res.data.rows
        return this.langData
      } catch (error) {}
    },
    async getList() {
      let res = await this.$http.getGptPromptList(this.params)
      this.tableData = res.data.rows
      this.total = res.data.rowCount
    },
    createPrompt() {
      this.$router.push({
        name: 'addGptPrompt'
      })
    },
    editPrompt(data) {
      this.$router.push({
        name: 'addGptPrompt',
        query: {
          id: data.id
        }
      })
    },

    async delPrompt(data) {
      try {
        await this.$confirm(null, this.$t('alertMsg.delConfirm'), {
          confirmButtonText: this.$t('commonMsg.confirm'),
          cancelButtonText: this.$t('commonMsg.cancel'),
          showClose: false,
          center: true
        })
        await this.$http.delGptPrompt({ ids: [data.id] })
        this.getList()
      } catch (error) {}
    },

    tableHandle({ type, data }) {
      switch (type) {
        case 'edit':
          this.editPrompt(data)
          break
        case 'del':
          this.delPrompt(data)
          break

        default:
          break
      }
    },
    changelang(val) {
      console.log(val)
      this.params.lang = val
      this.getList()
    },
    listSearchEvn(val) {
      this.params.query = val
      this.getList()
    },
    pageNum(page) {
      this.params.page = page
      this.getList()
    }
  },
  mounted() {
    this.getCountryList()
    this.getList()
  }
}
</script>
